import ApiBase from '../ApiBase';

class ScheduledReportReports extends ApiBase {
    route = '/admin/scheduled-report-reports';
}

export default new ScheduledReportReports();
